export type CompanyBugChipColor = "error" | "warning" | "success" | "info" | "primary" | "default";

export type CompanyBugChipConfig = {
    l10nId: string | null;
    fallback: string;
    color: CompanyBugChipColor;
};

export const newStatuses = new Set(["NEW"]);
export const underRepairStatuses = new Set(["INPROGRESS", "SENDTOTEST"]);
export const fixedStatuses = new Set(["FIXED"]);
export const rejectedStatuses = new Set(["REJECTED"]);
// "Reported" filter groups every status that is still open on the client side
export const reportedStatuses = new Set([...newStatuses, ...underRepairStatuses]);
export const normalizeStatus = (status: string | null | undefined) => (status ?? "").trim().toUpperCase();

export const getPriorityChipConfig = (priority: string | null | undefined): CompanyBugChipConfig => {
    switch ((priority ?? "").trim().toUpperCase()) {
        case "H": return { l10nId: "bug-report-priority-high", fallback: "High", color: "error" };
        case "M": return { l10nId: "bug-report-priority-medium", fallback: "Medium", color: "warning" };
        case "L": return { l10nId: "bug-report-priority-low", fallback: "Low", color: "success" };
        default: return { l10nId: null, fallback: priority || "-", color: "default" };
    }
};

export const getStatusChipConfig = (status: string | null | undefined): CompanyBugChipConfig => {
    const normalized = normalizeStatus(status);
    if (newStatuses.has(normalized)) return { l10nId: "company-bugs-new", fallback: "New", color: "info" };
    if (underRepairStatuses.has(normalized)) return { l10nId: "company-bugs-under-repair", fallback: "Under Repair", color: "warning" };
    if (fixedStatuses.has(normalized)) return { l10nId: "company-bugs-fixed", fallback: "Fixed", color: "success" };
    if (rejectedStatuses.has(normalized)) return { l10nId: "company-bugs-rejected", fallback: "Rejected", color: "error" };
    return { l10nId: null, fallback: status || "-", color: "default" };
};
